'use client'

import { useEffect, useRef, useState } from 'react'
import { useAuthProvider } from '../../providers/AuthProvider'
import { EmailStep } from '../EmailStep/EmailStep'
import { OtpStep } from '../OtpStep/OtpStep'

type LoginStep = 'email' | 'otp'

type PasswordlessLoginProps = {
  onSuccess: () => void
}

export function PasswordlessLogin({ onSuccess }: PasswordlessLoginProps) {
  const { status, error, initiateLogin, verifyOtp, clearError } =
    useAuthProvider()
  const [step, setStep] = useState<LoginStep>('email')
  const [email, setEmail] = useState('')
  const onSuccessRef = useRef(onSuccess)
  onSuccessRef.current = onSuccess

  useEffect(() => {
    if (status === 'authenticated') {
      onSuccessRef.current()
    }

    if (status === 'awaiting-otp') {
      setStep('otp')
    }
  }, [status])

  const isLoading = status === 'sending' || status === 'verifying'

  function emailSubmitHandler(submittedEmail: string) {
    setEmail(submittedEmail)
    clearError()
    initiateLogin(submittedEmail)
  }

  function otpSubmitHandler(otp: string) {
    clearError()
    verifyOtp(email, otp)
  }

  function resendHandler() {
    clearError()
    initiateLogin(email)
  }

  if (step === 'otp') {
    return (
      <OtpStep
        email={email}
        isLoading={isLoading}
        error={
          status === 'awaiting-otp' || status === 'unauthenticated'
            ? error
            : null
        }
        onSubmit={otpSubmitHandler}
        onResend={resendHandler}
      />
    )
  }

  return (
    <EmailStep
      isLoading={isLoading}
      error={status === 'unauthenticated' ? error : null}
      onSubmit={emailSubmitHandler}
    />
  )
}
